/**
 * Enum for the result of a game continue (resume). Used by the frontend to decide whether to open the entry link.
 */
export enum GameContinueStatus {
  Success = 'Success',
  WrongCountry = 'WrongCountry',
  GameNotAvailable = 'GameNotAvailable',
  ICloudPrivateRelay = 'ICloudPrivateRelay',
}

